import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Link from '@material-ui/core/Link';

export default function AlertDialog(props) {
  const [open, setOpen] = React.useState(props.open);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    props.setShowBadKeyTooltip(false);
  };

  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Not a Valid Botsheets Key
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Do you have a Botsheets Key?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            That doesn't look like a Botsheets Action Key. The only way to get a Botsheets Action Key is from our Botsheets Messenger bot. Please get a key if you have not
            already.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Link href="https://m.me/botsheets?ref=w7955135" target="_blank">
            <Button onClick={handleClose} color="primary">
              Get My Key
            </Button>
          </Link>
          <Button onClick={handleClose} color="primary" autoFocus>
            Try again
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
